export default {
    meta: {
        title: '标准版-搜索地址'
    }
};
